<template>
	<ion-page>
		<ion-tabs>
			<ion-router-outlet></ion-router-outlet>
			<ion-tab-bar slot="bottom">
				<ion-tab-button tab="login" href="/gym/front">
					<i class="wn-icon home"></i>
					<ion-label  v-if="this.activeHost.useTabDescriptions">{{ loggedIn ? $t("tabs.frontPage") : $t('tabs.login')}}</ion-label>
				</ion-tab-button>

				<ion-tab-button tab="today"  href="/gym/today">
					<i class="wn-icon notification"></i>
					<ion-label  v-if="this.activeHost.useTabDescriptions">{{$t('tabs.news')}}</ion-label>
				</ion-tab-button>

				<ion-tab-button tab="fitness" @click="() => $router.push(`today/article/5741`)">
					<i class="wn-icon calendar"></i>
					<ion-label v-if="this.activeHost.useTabDescriptions">
						{{$t('tabs.calendar')}}
					</ion-label>
				</ion-tab-button>
				
				<ion-tab-button tab="account" @click="() => $router.push(`today/article/5740`)">
					<i class="wn-icon account"></i>
					<ion-label  v-if="this.activeHost.useTabDescriptions">{{$t('tabs.account')}}</ion-label>
				</ion-tab-button>

			</ion-tab-bar>
		</ion-tabs>
	</ion-page>
</template>

<script>
import { IonTabBar, IonTabButton, IonTabs, IonRouterOutlet } from "@ionic/vue";
import { mapState, mapGetters } from "vuex";

export default {
	name: "GymTabs",
	components: { IonTabs, IonTabBar, IonTabButton, IonRouterOutlet },
	computed: {
		...mapState({loggedIn: state => state.user.loggedIn}),
		...mapGetters({ activeHost: "common/activeHost" }),
	}
};
</script>

<style scoped>
ion-tab-button.hide {
  position: absolute;
  visibility: hidden;
  pointer-events: none;
}
</style>